import Loading from "modules/layout/components/Loading";
import useReleases from "../hooks/useReleases";
import ReleaseListItem from "./ReleaseListItem";

const ReleasesList = () => {
  const { releases, loading } = useReleases();
  if (loading) return <Loading />;

  return (
    <div className="row mt-5">
      {releases.map((release) => (
        <div className="col-lg-6 mb-4" key={release._id}>
          <ReleaseListItem release={release} />
        </div>
      ))}
    </div>
  );
};

export default ReleasesList;
